// extracted by mini-css-extract-plugin
var _1 = "active-UZHm6";
var _2 = "block-VRaP7";
var _3 = "bottom-_OXg6";
var _4 = "btn-M7JMH";
var _5 = "combine-mg7E3";
var _6 = "det-ra63d";
var _7 = "details-Ai_bN";
var _8 = "dif-pQ9YO";
var _9 = "down-dQah3";
var _a = "item-taWXj";
var _b = "itemsWrapper-uCESf";
var _c = "merge-gJ5Fn";
var _d = "name-F0Z6A";
var _e = "noDuplicates-mOVw5";
var _f = "none-BbGKe";
var _10 = "price-O_okr";
var _11 = "qty-hPgtN";
var _12 = "section-PxMo3";
var _13 = "sub-Jaj5C";
var _14 = "title-DxOLe";
var _15 = "up-KT9gx";
var _16 = "wrap-AF4FO";
export { _1 as "active", _2 as "block", _3 as "bottom", _4 as "btn", _5 as "combine", _6 as "det", _7 as "details", _8 as "dif", _9 as "down", _a as "item", _b as "itemsWrapper", _c as "merge", _d as "name", _e as "noDuplicates", _f as "none", _10 as "price", _11 as "qty", _12 as "section", _13 as "sub", _14 as "title", _15 as "up", _16 as "wrap" }
